import { createSelector } from '@reduxjs/toolkit';

const selectUnapproved = state => state.unapproved;

export const selectOrdersUnapproved = createSelector(
  selectUnapproved,
  state => state.data
);

export const selectIsLoading = createSelector(
  selectUnapproved,
  state => state.isLoading
);

export const selectCurrentPage = createSelector(
  selectUnapproved,
  state => state.pagination.pageNumber || 1
);

export const selectHasMore = createSelector(
  selectUnapproved,
  state => state.hasMore
);

export const selectProcessingAction = createSelector(
  selectUnapproved,
  state => state.processingAction
);

export const selectDeclineDialogOpened = createSelector(
  selectUnapproved,
  state => state.declineDialogOpened
);

export const selectApproveDialogOpened = createSelector(
  selectUnapproved,
  state => state.approveDialogOpened
);

export const selectShowDeclinedSuccesSnackBar = createSelector(
  selectUnapproved,
  state => !!state.declinedSuccesful
);

export const selectShowDeclinedErrorSnackBar = createSelector(
  selectUnapproved,
  state => state.declinedSuccesful !== null && !state.declinedSuccesful
);

export const selectUnapprovedTotalWO = createSelector(
  selectUnapproved,
  state => state?.pagination?.totalResults
);
